export enum SelectType {
	Simple = 1,
	Multiple = 2
}
